// src/store/store.js
import { combineReducers } from 'redux';
import apiReducer from './apiReducer';
import { configureStore } from '@reduxjs/toolkit';
import { TradeReducer } from '../services/redux/tradeManagement';

const rootReducer = combineReducers({
  api: apiReducer,
  trade: TradeReducer,
});

const store = configureStore({
  reducer: rootReducer, // use 'reducer' instead of 'rootReducer'
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(), // Removed duplicate thunk middleware
});

export default store;
